module.exports = __webpack_public_path__ + "img/logo-magnet.fd7a1ce6.png";